import * as React from "react";
import styles from "./product-carousel-component.module.scss";
import { Carousel } from "react-responsive-carousel";
import { transformImage } from "../../../utils";

interface IProductCarouselComponent {
  images?: Array<{ url: string }>;
  className?: string;
  idxSelected?: number;
  onSelect?: any;
  onClickModal?(idxSelected?: number): void;
}

const ProductImages = React.memo(function ProductImages({
  images,
  onClickItem,
}: {
  images: Array<{ url: string }>;
  onClickItem: (index: number) => void;
}) {
  return (
    <Carousel
      className={styles.carousel}
      onClickItem={onClickItem}
      showArrows={false}
      showStatus={false}
      autoPlay={false}
      showThumbs={false}
      swipeable={true}
    >
      {images && images.length > 1
        ? images.map((image, index) => {
            return (
              <img
                alt={`product image ${index}`}
                key={index}
                // , ${ transformImage(image.image, '1557x1557', undefined, userAgent.hasWebp).replace('full-fit-in/', '') } 3x
                srcSet={`${transformImage(image.url, "1038x1038").replace(
                  "full-fit-in/",
                  ""
                )} 2x`}
                src={transformImage(image.url, "671x671").replace(
                  "full-fit-in/",
                  ""
                )}
              />
            );
          })
        : null}
    </Carousel>
  );
});

export default class ProductCarouselComponent extends React.PureComponent<
  IProductCarouselComponent,
  {}
> {
  public state = {
    selected: transformImage(
      Array.isArray(this.props.images) && this.props.images[0]
        ? this.props.images[0].url
        : "",
      "519x519",
      undefined,
      false
    ).replace("full-fit-in/", ""),
  };

  public onChangeImage = (idxSelected: number) => {
    if (this.props.images) {
      this.setState({
        selected: transformImage(
          this.props.images[idxSelected].url,
          "519x519"
        ).replace("full-fit-in/", ""),
      });
    }
  };

  public onSelect = (idxSelected: number) => {
    if (typeof this.props.onSelect === "function") {
      this.props.onSelect(idxSelected);
    }
    this.onChangeImage(idxSelected);
  };

  public onClickItem = (idxSelected: number) => {
    this.props.onClickModal(idxSelected);
  };

  public getClassName = (index: number) => {
    if (this.props.idxSelected === index) {
      return styles.active + " image-container";
    }
    return "image-container";
  };

  public onClickImage = () => {
    this.props.onClickModal();
  };

  get getClassNameContainer() {
    let text = styles.product + " col-6 col-sm-12 col-md-12";
    if (this.props.className) {
      text += " " + this.props.className;
    }

    if (this.props.images && this.props.images.length === 1) {
      text += " " + styles.single;
    }
    return text;
  }

  public render() {
    return (
      <div className={this.getClassNameContainer}>
        <section className={`${styles.sidebar} col-md-2 col-sm-0 col-2`}>
          {this.props.images && this.props.images.length > 1
            ? this.props.images.map((image, index) => {
                return (
                  <div
                    key={index}
                    className={this.getClassName(index)}
                    onClick={this.onSelect.bind(this, index)}
                  >
                    <img
                      alt={`sm_image ${index}`}
                      onClick={this.onSelect.bind(this, index)}
                      src={transformImage(image.url, "85x85").replace(
                        "full-fit-in/",
                        ""
                      )}
                      srcSet={`${transformImage(image.url, "170x170").replace(
                        "full-fit-in/",
                        ""
                      )} 2x, ${transformImage(image.url, "255x255").replace(
                        "full-fit-in/",
                        ""
                      )} 3x`}
                    />
                  </div>
                );
              })
            : null}
        </section>
        <main
          className={`col-md-10 ${
            this.props.images && this.props.images.length === 1
              ? "col-12"
              : "col-10"
          } col-sm-12`}
        >
          <div>
            <img
              alt="image selected"
              // , ${this.state.selected.replace('519x519', '1557x1557')} 3x
              srcSet={`${this.state.selected.replace(
                "519x519",
                "1038x1038"
              )} 2x`}
              src={this.state.selected}
              onClick={this.onClickImage}
            />
          </div>
        </main>
        <ProductImages
          images={this.props.images}
          onClickItem={this.onClickItem}
        />
      </div>
    );
  }
}
